import { nodeCategories } from "../../../../config/drawingConstants";

export const GROUP_NODE_TYPES: readonly string[] = [
  nodeCategories.farmGate,
  nodeCategories.processGate,
  nodeCategories.ingredientGate
];

export const MULTIPLE_ENDPOINTS_ERROR =
  "Only one endpoint is allowed per calculation. Please remove the extra endpoint(s) before continuing.";
